<template>
    <v-menu offset-y left>
    <template slot="activator">
      <v-btn color="darkgrey"  flat icon class="button-element" ><v-icon>arrow_drop_down</v-icon></v-btn>
    </template>
    <v-list >
      <v-list-tile v-for="(item, index) in sanctions" :key="index" @click="changeCurrentSanction(item)" :disabled="!canEdit">
        <v-list-tile-title>{{ item }}</v-list-tile-title>
      </v-list-tile>
    </v-list>
  </v-menu>
</template>

<script>
export default {
  props: {
    field: Object,
    sanctions: Array,
    sanction: String,
    canEdit: Boolean
  },

  methods: {
    changeCurrentSanction (item) {
      this.$emit('changeCurrentSanction', item)
    }
  }
}
</script>

<style scoped>
.button-element {
  margin: 0;
}
</style>
